import { render, staticRenderFns } from "./VehicleCustomer.vue?vue&type=template&id=567bb97d"
import script from "./VehicleCustomer.vue?vue&type=script&lang=js"
export * from "./VehicleCustomer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('567bb97d')) {
      api.createRecord('567bb97d', component.options)
    } else {
      api.reload('567bb97d', component.options)
    }
    module.hot.accept("./VehicleCustomer.vue?vue&type=template&id=567bb97d", function () {
      api.rerender('567bb97d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/vehicle/VehicleCustomer.vue"
export default component.exports